import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { Subtitle } from "@/components/dialog/DialogLayout";
import { useStore } from "@/store";

import { Invites } from "./Invites";
import { MemberList } from "./MemberList";

export const Members = observer(function Members() {
  const t = useTranslations();
  const { team } = useStore().dialog.teamDialog;

  if (!team) return null;

  return (
    <div className="flex flex-col">
      <Subtitle title={t("teamDialog.inviteMembers")} className="mb-2.5" />
      <Invites team={team} />
      <MemberList team={team} />
    </div>
  );
});
